import { render } from "./PlayerSearch.vue?vue&type=template&id=4ad4bbf2&scoped=true"
import script from "./PlayerSearch.vue?vue&type=script&lang=js"
export * from "./PlayerSearch.vue?vue&type=script&lang=js"

import "./PlayerSearch.vue?vue&type=style&index=0&id=4ad4bbf2&scoped=true&lang=css"

import exportComponent from "C:\\frotend\\d7m_front_sindico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ad4bbf2"]])

export default __exports__